import { createAsyncThunk } from '@reduxjs/toolkit';
import { getValveConnectorGrids } from 'application/components/api/ValveConnectorGrid';
import { selectComponentState } from 'projectRedux/store';

export const fetchAsyncValveConnectorGrids = createAsyncThunk(
  'components/fetchAsyncValveConnectorGrids',
  async (data: {}, thunkAPI) => {
    const response = await getValveConnectorGrids();
    return response;
  },
  {
    condition(arg, thunkAPI) {
      return selectComponentState(thunkAPI.getState()).valveConnectorGrids.loading === 'init';
    },
  }
);
